import React from 'react';
import './styles.css';
import {default as ModalWrap} from 'react-overlays/Modal'
import { CSSTransition } from 'react-transition-group';

const Modal = (props) => {
  return <ModalWrap {...props}
                style={{}}
                aria-labelledby="modal-label"
                renderDialog={() =>
                  <div className={"modal-wrapper" + (props.mobileFullWidth ? " mobile-full-width" : "")}>
                    <CSSTransition
                      in={true}
                      classNames={props.animationClass ? props.animationClass : "modal-animation"}
                      timeout={1}
                      appear>
                      <div className="modal-container">{props.children}</div>
                    </CSSTransition>
                  </div>}
                renderBackdrop={(props)=><div {...props} className="modal-backdrop"/>}>
  </ModalWrap>
};

export default Modal;
